<div class="frame-in">
    <div id="game-container" class="phaser-3 font-QuraneraV3"></div>
</div>
